<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-8">
          <segment-new-form>
          </segment-new-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import SegmentNewForm from './Segments/SegmentNewForm.vue'

  export default {
    components: {
      SegmentNewForm
    }
  }

</script>
<style>

</style>
